var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout profiles" },
    [
      _c("remove-item-modal", {
        ref: "removeItemModal",
        on: { remove: _vm.onItemRemoved },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("h2", { staticClass: "layout-title" }, [_vm._v("Анкеты")]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  responsive: true,
                  size: "small",
                  icon: { icon: "plus", color: "primary" },
                  label: "Новая анкета",
                },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "create-profile" })
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "layout-content" },
        [
          !_vm.inited
            ? _c("c-loader", {
                staticClass: "loader",
                attrs: {
                  active: _vm.loading,
                  label: "Данные загружаются",
                  height: 450,
                },
              })
            : _vm.isEmpty
            ? _c("div", { staticClass: "empty-message" }, [
                _vm._v("Анкет пока нет"),
              ])
            : [
                _c("filters", {
                  attrs: { filters: _vm.filters },
                  on: { apply: _vm.applyFilters },
                }),
                !_vm.loading && _vm.totalCount === 0
                  ? _c("div", { staticClass: "empty-message" }, [
                      _vm._v(
                        " Ничего не найдено. Попробуйте изменить параметры поиска. "
                      ),
                    ])
                  : _vm._e(),
                _c("list", {
                  attrs: { list: _vm.list, loading: _vm.loading },
                  on: { nextPage: _vm.nextPage, removeItem: _vm.removeItem },
                }),
              ],
        ],
        2
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          !_vm.loading
            ? _c("show-items", {
                attrs: { count: _vm.list.length, total: _vm.totalCount },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }